import { render, staticRenderFns } from "./DialogBranch.vue?vue&type=template&id=1141e839&"
import script from "./DialogBranch.vue?vue&type=script&lang=ts&"
export * from "./DialogBranch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports